import { BaseLocation } from '../models/base-location';

export class District extends BaseLocation {
}
